module.exports = __webpack_public_path__ + "img/start_place.1ecb4f55.png";